module.exports = __webpack_public_path__ + "ef0c036d2d8d1a8402863fdf7a37bfd1.svg";